import { InputContainer, respondTo, StyledInputContainer } from "@animech/ui";
import { css } from "@emotion/react";
import styled from "@emotion/styled";

export const CustomInputContainer = styled(InputContainer)`
	${({ theme }) => css`
		margin-top: 0 !important;
		margin-bottom: ${theme.dimensions.margin.small} !important;

		${StyledInputContainer.Label} {
			font-size: ${theme.typography.fontSize.large};
			font-weight: ${theme.typography.fontWeight.light};

			${respondTo(theme, "mobile")} {
				font-size: ${theme.typography.fontSize.base};
			}
		}
	`}
`;
